define('bindingHandlers/chartLegend',[
    'lib/lodash4',
    'lib/knockout',
    'lib/d3'
], function (
    _,
    ko,
    d3
) {

    'use strict';

    var RIGHT_MARGIN = 180;
    var LEGEND_DIMENSION = 18;
    var LEGEND_TEXT_SPACE = LEGEND_DIMENSION + 10;
    var CHART_LEGEND_DOMDATA_KEY = "chart-legend-binding-data";

    var getDomDataValue = function (element, key) {
        var domData = ko.utils.domData.get(element, CHART_LEGEND_DOMDATA_KEY);

        if(domData && domData[key]){
            return domData[key];
        }
    };

    var updateDomData = function (element, key, value) {

        var domData = ko.utils.domData.get(element, CHART_LEGEND_DOMDATA_KEY);
        domData[key] = value;

        ko.utils.domData.set(element, CHART_LEGEND_DOMDATA_KEY, domData);

    };

    var styleTargetLine = function(groups, svg) {
        var targetNode = svg.select("g").select(".sub._" + groups.length).select("path");
        targetNode.attr("class", "line target");

    };

    var getMissingSeriesIndexes = function (svg, n) {
        var className, indexes = [];
        for(var i = 0; i < n; i++) {
            className = ".sub._" + i;
            var node = svg.select("g").select(className);
            if (!node.empty()) {
                if (node.style("display") === "none") {
                    indexes.push(i);
                }
            }
        }
        return indexes;
    };

    var adjustYScaling = function(groups, chart, seriesToRemove, svg, target) {
        var min, max = 0;
        var str = "", counter = 0;//, yScale;
        var seriesOn = 0;

        _.each(groups, function (group) {
            if (!_.includes(seriesToRemove, counter)) {
                _.each(group.all(), function (datum) {
                    seriesOn++;
                    if (_.isUndefined(min) || datum.value < min) {
                        min = datum.value;
                    }
                    if (datum.value > max) {
                        max = datum.value;
                    }
                    str += datum.value;
                    str += " ";
                });
            }
            counter++;
        });

        if (!_.isUndefined(target)  && !_.includes(seriesToRemove, counter)) {
            _.each(target.all(), function (datum) {
                seriesOn++;
                if (_.isUndefined(min) && (seriesOn === 0)) {
                    min = 0;
                }
                if (datum.value > max) {
                    max = datum.value * 1.1;
                }
                str += datum.value;
                str += " ";
            });
        }

        if (_.isUndefined(min)) {
            min = 0;
        }

        if ((min === max) && seriesOn > 0) {
            max = min + 0.1;
        }

        if(!_.isUndefined(min) && !_.isUndefined(max)){
            chart.y().domain([min, max]);
        }

        chart.renderYAxis();

        chart.redraw();
    };


    var renderLegend = function(colors, titles, svg, width, groups, chart, seriesData, element, target) {

        var restoreData = (_.keys(seriesData).length > 0) ? true : false;

        var legendClickHandler = function (e) {

            var seriesIndex = titles.indexOf(e);
            var legendNode = chart.svg().selectAll(".legend")[0][seriesIndex];

            var charts = chart.children();

            charts[seriesIndex].toggleVisibility();

            if (d3.select(this).style("opacity") === "1") {

                d3.select(this).style("opacity", 0.5);

                if (legendNode) {
                    d3.select(legendNode).select("rect").style("opacity", 0.5).style("fill-opacity", 0);
                }

                seriesData[seriesIndex] = false;

            } else {

                d3.select(this).style("opacity", 1);

                if (legendNode) {
                    d3.select(legendNode).select("rect").style("opacity", 1).style("fill-opacity", 1);
                }

                seriesData[seriesIndex] = true;
            }

            adjustYScaling(groups, chart, getMissingSeriesIndexes(svg, titles.length), svg, target);

            updateDomData(element, "seriesData", seriesData);

        };

        svg.selectAll(".legend").remove();
        var legend = svg.selectAll(".legend")
            .data(colors.domain())
            .enter().append("g")
            .attr("class", "legend")
            .attr("transform", function(d, i) { return "translate(" + (-2 * LEGEND_DIMENSION) +"," + ((i + 1) * 22) + ")"; });

        // draw legend colored rectangles
        legend.append("rect")
            .attr("x", width - RIGHT_MARGIN)
            .attr("width", LEGEND_DIMENSION)
            .attr("height", LEGEND_DIMENSION)
            .attr("class","legend-handle")
            .style("fill", colors)
            .style("stroke-width", "1")
            .style("fill-opacity", "1")
            .style("stroke", "#000000")
            .on("click", legendClickHandler);

        // draw legend text
        legend.append("text")
            .attr("x", width - RIGHT_MARGIN + LEGEND_TEXT_SPACE)
            .attr("y", LEGEND_DIMENSION / 2)
            .attr("dy", ".35em")
            .text(function(d) { return d; })
            .on("click", legendClickHandler);

        if(restoreData){

            var legendHandles = svg.selectAll(".legend-handle");

            _.forOwn(seriesData, function(value, key){

                var seriesIndex = key;
                var seriesState = value;
                var className;
                var tooltipClassName;
                var legendNode;
                var legendHandle;

                legendNode = svg.selectAll(".legend")[0][seriesIndex];
                legendHandle = legendHandles[0][seriesIndex];

                if (seriesIndex.toString()) {
                    className = ".sub._" + seriesIndex;
                    tooltipClassName = "._" + seriesIndex + " .dc-tooltip";
                }

                // We should only even need to toggle to a false state on restore

                if(seriesState === false){

                    d3.select(legendHandle).style("fill-opacity", 0).style("opacity", 0.5);

                    chart.children()[seriesIndex].restoreVisibilityState();

                    if (legendNode) {
                        d3.select(legendNode).select("text").style("opacity", 0.5);
                    }

                }

            });

        }

        if (!_.isUndefined(target)) {
            styleTargetLine(groups, svg);
        }

    };

    ko.bindingHandlers.chartLegend = {

        init: function(element, valueAccessor){

            // **************************************************************************
            // Variables
            // **************************************************************************

            var bindingData = ko.unwrap(valueAccessor());
            var colors = ko.unwrap(bindingData.colors),
                titles = ko.unwrap(bindingData.titles),
                svg    = ko.unwrap(bindingData.svg),
                width  = ko.unwrap(bindingData.width),
                groups = ko.unwrap(bindingData.groups),
                chart  = ko.unwrap(bindingData.chart),
                target = ko.unwrap(bindingData.target);

            if(_.isUndefined(colors)){
                throw new Error("The chartLegend binding requires a color scale.");
            }

            if(_.isUndefined(titles)){
                throw new Error("The chartLegend binding requires an array of series titles.");
            }

            if(_.isUndefined(svg)){
                throw new Error("The chartLegend binding requires the svg object.");
            }

            if(_.isUndefined(width)){
                throw new Error("The chartLegend binding requires the width of the chart element.");
            }

            if(_.isUndefined(groups)){
                throw new Error("The chartLegend binding requires at least one chart grouping.");
            }

            if(_.isUndefined(chart)){
                throw new Error("The chartLegend binding requires a dc chart object.");
            }

            ko.utils.domData.set(element, CHART_LEGEND_DOMDATA_KEY, {
                "seriesData": {}
            });

            renderLegend(colors, titles, svg, width, groups, chart, {}, element, target);

        },

        update: function(element, valueAccessor){

            // **************************************************************************
            // Variables
            // **************************************************************************

            var bindingData = ko.unwrap(valueAccessor());
            var colors = ko.unwrap(bindingData.colors),
                titles = ko.unwrap(bindingData.titles),
                svg    = ko.unwrap(bindingData.svg),
                width  = ko.unwrap(bindingData.width),
                groups = ko.unwrap(bindingData.groups),
                chart  = ko.unwrap(bindingData.chart),
                target  = ko.unwrap(bindingData.target);

            if(_.isUndefined(colors)){
                throw new Error("The chartLegend binding requires a color scale.");
            }

            if(_.isUndefined(titles)){
                throw new Error("The chartLegend binding requires an array of series titles.");
            }

            if(_.isUndefined(svg)){
                throw new Error("The chartLegend binding requires the svg object.");
            }

            if(_.isUndefined(width)){
                throw new Error("The chartLegend binding requires the width of the chart element.");
            }

            if(_.isUndefined(groups)){
                throw new Error("The chartLegend binding requires at least one chart grouping.");
            }

            if(_.isUndefined(chart)){
                throw new Error("The chartLegend binding requires a dc chart object.");
            }

            var seriesData = getDomDataValue(element,"seriesData");

            renderLegend(colors, titles, svg, width, groups, chart, seriesData, element, target);

        }

    };

});

